import { AxiosResponse } from 'axios';

import { HttpClient } from 'api/HttpClient';
import { Lender } from 'enums/ApplicationsVariables';

export interface UpdateCoOwnerDto {
  applicationId: string;
  email: string;
  lender: Lender;
  phoneNumber?: string;
  last4SSN?: string;
}

export default class CoOwnersApi extends HttpClient {
  public constructor() {
    super(process.env.REACT_APP_API_URL + '/coOwners' || '');
  }

  public async updateInformation(updateCoOwnerDto: UpdateCoOwnerDto): Promise<void> {
    return this.instance.put('/update', updateCoOwnerDto).then((response: AxiosResponse<void>) => response.data);
  }
}

export const coOwnersApi = new CoOwnersApi();
